import { connect, mapProps } from '@formily/react';
import { CnOSSUpload as _CnOSSUpload, } from '@/components/cn-oss-upload';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnOSSUpload = connect(_CnOSSUpload, mapProps(mapSize, mapStatus));
CnOSSUpload.displayName = 'CnOSSUpload';
